import script from "./EducationView.vue?vue&type=script&lang=ts&setup=true"
export * from "./EducationView.vue?vue&type=script&lang=ts&setup=true"

import "./EducationView.vue?vue&type=style&index=0&id=3aa7c590&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aa7c590"]])

export default __exports__